var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { trackEvent } from '@raisin/events-tracking';
import { goToDeProdPensionLogoutPage, goToLoginPage, isPensionLogoutNeeded, keycloakLogout, cleanUpSessionData, } from '@raisin/cp-utils';
import { METHODS, createAsyncAction } from '../../../api';
import messages from './messages';
import { LOGOUT_SUCCEEDED } from '../../../eventsTracking';
const handleLogout = ({ userManagementPensionLogout, userManagementCallObsLogout, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield keycloakLogout();
        cleanUpSessionData();
        if (userManagementCallObsLogout) {
            yield createAsyncAction('logout', METHODS.POST);
        }
        const pensionLogoutNeeded = userManagementPensionLogout && isPensionLogoutNeeded();
        trackEvent(Object.assign({}, LOGOUT_SUCCEEDED));
        if (pensionLogoutNeeded) {
            goToDeProdPensionLogoutPage();
        }
        else {
            goToLoginPage({ refererRequired: false });
        }
    }
    catch (e) {
        if (e instanceof Error) {
            throw new Error(e.message);
        }
    }
});
export const getActionItems = ({ t, userManagementPensionLogout, userManagementCallObsLogout, }) => [
    {
        id: 'logout-button',
        type: 'text',
        title: t(messages.logout),
        href: '',
        callback: () => __awaiter(void 0, void 0, void 0, function* () {
            yield handleLogout({
                userManagementPensionLogout,
                userManagementCallObsLogout,
            });
        }),
    },
];
//# sourceMappingURL=actionItems.js.map